import React, { useState } from 'react';
import { 
  Users, 
  Briefcase, 
  Wind, 
  Cog, 
  Fuel,
  Calendar,
  TagIcon
} from 'lucide-react';

const CarCard = ({ car }) => (
  <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 w-full max-w-sm mx-auto">
    <div className="relative">
      <img 
        src={car.image} 
        alt={car.model} 
        className="w-full h-56 object-cover rounded-t-xl"
      />
      <div className="absolute top-3 right-3 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
        {car.category}
      </div>
    </div>
    
    <div className="p-6">
      <h3 className="text-2xl font-bold mb-4 text-gray-800">{car.model}</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="flex items-center gap-2 text-gray-600">
          <Users size={18} className="text-red-500" />
          <span>{car.seats} seats</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <Briefcase size={18} className="text-red-500" />
          <span>{car.luggage}</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <Wind size={18} className="text-red-500" />
          <span>{car.airCon ? 'AC' : 'No AC'}</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <Cog size={18} className="text-red-500" />
          <span>{car.transmission}</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <Fuel size={18} className="text-red-500" />
          <span>{car.gas}</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <Calendar size={18} className="text-red-500" />
          <span>{car.year}</span>
        </div>
        
        <div className="flex items-center gap-2 text-gray-600">
          <TagIcon size={18} className="text-red-500" />
          <span>{car.category}</span>
        </div>
      </div>
      
      <button className="w-full mt-6 bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg font-semibold transition-colors duration-300">
        Book Now
      </button>
    </div>
  </div>
);

function Kendaraan() {
  const cars = [
    // Small-size
    { 
      id: 1, 
      model: 'Mercedes S 450', 
      image: 'https://cvt.sgp1.cdn.digitaloceanspaces.com/file-1646117868157.jpg',  
      seats: 5, 
      luggage: '2 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2023 
    },
    { 
      id: 2, 
      model: 'Mercedes S 450', 
      image: 'https://imgcdnused.carbay.com/tr:w-500,h-333/car_image/52024/1719463926713.jpeg',  
      seats: 5, 
      luggage: '2 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2019 
    },

    // Mid-size
    { 
      id: 3, 
      model: 'Mercedes V Class', 
      image: 'https://img.cintamobil.com/crop/490x310/2021/06/08/E7uYC7dI/v-class-3-7652.jpg',  
      seats: 5, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'mini van', 
      year: 2023 
    },
    { 
      id: 4, 
      model: 'Honda Accord', 
      image: 'https://di-uploads-pod40.dealerinspire.com/hondaofclevelandheights/uploads/2022/11/2023-honda-accord-interior-and-exterior.jpg',  
      seats: 5, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'mid-size', 
      year: 2023 
    },

    // Luxury
    { 
      id: 5, 
      model: 'Toyota Camry', 
      image: 'https://static.wixstatic.com/media/261cbb_14776de546914349a7ff11e8a08f3cfc~mv2.png/v1/fill/w_688,h_408,al_c,q_85,enc_avif,quality_auto/261cbb_14776de546914349a7ff11e8a08f3cfc~mv2.png',  
      seats: 5, 
      luggage: '4 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Diesel', 
      category: 'mid-size', 
      year: 2024 
    },
    { 
      id: 6, 
      model: 'BMW 7 Series', 
      image: 'https://images.prod.seva.id/BMW/7%20series%20740Li%20Opulence/main_color/main_banner_BMW_740LiOpulence_Black_Sapphire.png',  
      seats: 5, 
      luggage: '4 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2022 
    },

    // SUV
    { 
      id: 7, 
      model: 'Hyundai Stargazer', 
      image: 'https://imgcdn.oto.com/large/gallery/exterior/15/2613/hyundai-stargazer-side-view-122455.jpg',  
      seats: 7, 
      luggage: '5 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'mid-size', 
      year: 2022 
    },
    { 
      id: 8, 
      model: 'Toyota Alphard', 
      image: 'https://static.wixstatic.com/media/261cbb_3c6bf7da5eff47c5a65d5424b28ecb5c~mv2.png/v1/fit/w_500,h_500,q_90/file.png',
      seats: 7, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2024 
    },

    // Mini Van
    { 
      id: 9, 
      model: 'Lexus 570', 
      image: 'https://imgcdn.oto.com/large/gallery/exterior/22/1351/lexus-lx-tilted-front-view-249796.jpg',  
      seats: 5, 
      luggage: '6 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2023
    },
    { 
      id: 10, 
      model: 'Mercedes E 300', 
      image: 'https://cdn1-production-images-kly.akamaized.net/dPmqMN5-qPWXwgV_RaHp5tL6W30=/750x0/smart/filters:quality(75):strip_icc():format(webp)/kly-media-production/medias/4409162/original/013847700_1682672348-mercedes-benz-e-class-11.jpg',  
      seats: 5, 
      luggage: '4 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2024
    },

    // Wedding
    { 
      id: 11, 
      model: 'Mercedes C Class', 
      image: 'https://image.made-in-china.com/226f3j00HsUqpevBZhkr/Mercedes-Benz-C-Class-Amg-2023-Amg-C-43-4matic-Sedan-Perjalanan-Edisi-Khusus-Mobil-Kecepatan-Tinggi-Mobil-Bekas.webp',  
      seats: 5, 
      luggage: '2 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2023
    },
    { 
      id: 12, 
      model: 'BMW 330 M Sport', 
      image: 'https://i.ytimg.com/vi/bVb5CGGun-Q/maxresdefault.jpg',  
      seats: 5, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2023 
    },
    { 
      id: 13, 
      model: 'Toyota Alphard', 
      image: 'https://asset.kompas.com/crops/J-5gjI5Y0AuQHB0bzuvxV4xr4tk=/0x0:872x581/1200x800/data/photo/2021/06/03/60b8728731d27.jpg',  
      seats: 7, 
      luggage: '6 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2022 
    },
    { 
      id: 14, 
      model: 'Mitsubishi Pajero', 
      image: 'https://www.mitsubishimadiunraya.com/wp-content/uploads/2020/02/6632fd200a6f7-mitsubishi-pajero-sport-edisi-2024-untuk-pasar-australia_665_374.jpg',  
      seats: 7, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'suv', 
      year: 2023 
    },
    { 
      id: 15, 
      model: 'Honda CRV', 
      image: 'https://blue.kumparan.com/image/upload/fl_progressive,fl_lossy,c_fill,q_auto:best,w_640/v1634025439/01g9bkmsphtqvt5hfq483g4kth.jpg',  
      seats: 7, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'suv', 
      year: 2022 
    },
    { 
      id: 16, 
      model: 'Innova Zenix', 
      image: 'https://mmc.tirto.id/image/otf/640x0/2022/11/23/innova-hybrid-zenix-ev--toyota_ratio-16x9.jpg',  
      seats: 7, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'suv', 
      year: 2023 
    },
    { 
      id: 17, 
      model: 'Range Rover Vogue', 
      image: 'https://media.ed.edmunds-media.com/land-rover/range-rover/2022/oem/2022_land-rover_range-rover_4dr-suv_p530-autobiography-lwb-5_fq_oem_1_1600.jpg',  
      seats: 5, 
      luggage: '3 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'luxury', 
      year: 2023 
    },
    { 
      id: 18, 
      model: 'Toyota Hiace', 
      image: 'https://statik.tempo.co/data/2022/04/07/id_1101279/1101279_720.jpg',  
      seats: 15, 
      luggage: '8 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'mini van', 
      year: 2023 
    },    
    { 
      id: 19, 
      model: 'Toyota Alphard', 
      image: 'https://sentrajakarta-rent.com/wp-content/uploads/2019/03/Alphard-Transformer-Putih-Terbaru-Sewa-Mobil-Pengantin-Rental-Mobil-Mewah-Jakarta-Wedding-Car-Jakarta-Rent-Car-Jakarta-43.jpg',  
      seats: 7, 
      luggage: '5 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'wedding', 
      year: 2022 
    },    
    { 
      id: 20, 
      model: 'Toyota Alphard', 
      image: 'https://sentrajakarta-rent.com/wp-content/uploads/2019/03/Alphard-Transformer-Putih-Terbaru-Sewa-Mobil-Pengantin-Rental-Mobil-Mewah-Jakarta-Wedding-Car-Jakarta-Rent-Car-Jakarta-43.jpg',  
      seats: 7, 
      luggage: '5 bags', 
       
      airCon: true, 
      transmission: 'Automatic', 
      gas: 'Petrol', 
      category: 'wedding', 
      year: 2024 
    },
  ];

  // Rest of the component logic would go here

  const categories = ['all', 'wedding', 'mid-size', 'luxury', 'suv', 'mini van'];
  const [selectedCategory, setSelectedCategory] = useState('all');

  const filteredCars = selectedCategory === 'all' 
    ? cars 
    : cars.filter(car => car.category === selectedCategory);

  return (
    <>
  <section className="relative py-16 bg-center" style={{
    backgroundImage: "url('https://www.kellyheckphotography.com/wp-content/uploads/2020/08/LR-Alpha-Sedan-Limo-9911-1.jpg')",
    backgroundSize: 'cover',
    height:'400px'
  }}>
    <div className="absolute inset-0 bg-black opacity-50"></div>
    <div className="relative flex items-center justify-center h-full px-4 text-center text-white">
      <div>
        <h1 className="text-3xl font-bold mb-4">Our Fleet</h1>
        <p className="text-lg">
          We are a premier car rental company that offers exceptional service and reliable vehicles to our customers. Our commitment to providing a hassle-free rental experience is at the core of everything we do, and we take pride in ensuring that every customer is satisfied with their rental.
        </p>
      </div>
    </div>
  </section>    
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8 text-gray-800">
          Our Fleet
        </h1>
        
        <div className="flex flex-wrap justify-center gap-2 mb-8">
          {categories.map(cat => (
            <button 
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`
                px-4 py-2 rounded-full font-medium transition-all duration-300
                ${selectedCategory === cat 
                  ? 'bg-red-500 text-white shadow-lg scale-105' 
                  : 'bg-white text-gray-600 hover:bg-red-50 hover:text-red-500 shadow'}
              `}
            >
              <span className="capitalize">{cat}</span>
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredCars.map(car => (
            <CarCard key={car.id} car={car} />
          ))}
        </div>
      </div>
    </div>
    </>
  );
}

export default Kendaraan;